<template>
  <v-card
    v-if="visible"
    id="price"
    elevation="0"
    class="mx-auto secondary rounded-0"
    :loading="price && price.loading"
  >
    <template slot="progress">
      <v-progress-linear color="accent" indeterminate></v-progress-linear>
    </template>

    <!-- <v-card id="price" elevation="0" class="mx-auto secondary rounded-0"> -->
    <CardHeader title="7. Din pris" />
    <v-card-text class="py-6 px-10" style="font-size: 12px;">
      <v-row no-gutters class="py-1 px-3 mb-3 white rounded">
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 6 : 2"
          class="px-2"
          align-self="center"
        >
          <span
            >{{
              price && price.transportprice && price.transportprice.description
                ? price.transportprice.description
                : "Turpris"
            }}
          </span>
          <v-tooltip
            bottom
            slot="append-outer"
            color="info"
            v-if="price && price.transportprice && price.transportprice.remark"
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="info">
                {{ helpIcon }}
              </v-icon>
            </template>
            <span>{{ price.transportprice.remark }}</span>
          </v-tooltip>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 2 : 8"
          class="px-2"
          align-self="center"
          style="text-align:center"
        >
          <div v-if="price && price.applicablefortimeflex">
            <b class="hidden-sm-and-down">
              Der kan opnås rabat ved længere afhentningsvindue!
            </b>

            <v-tooltip bottom color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="hidden-md-and-up"
                  v-on="on"
                  v-bind="attrs"
                  color="info"
                >
                  {{ dicsountIcon }}
                </v-icon>
              </template>
              <span class="hidden-md-and-up"
                >Der kan opnås rabat ved længere afhentningsvindue!</span
              >
            </v-tooltip>
          </div>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
          class="px-2"
          align-self="center"
          style="text-align:right"
        >
          <span>
            {{
              price && price.transportprice && price.transportprice.price
                ? price.transportprice.price
                : 0 | formatDouble
            }}
            {{
              price && price.transportprice && price.transportprice.currency
                ? price.transportprice.currency
                : price.currency
            }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1 px-3 mb-3 white rounded">
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 8 : 10"
          class="px-2"
          align-self="center"
        >
          <span
            >{{
              price && price.waitingprice && price.waitingprice.description
                ? price.waitingprice.description
                : "Ventetid"
            }}
          </span>
          <v-tooltip
            bottom
            slot="append-outer"
            color="info"
            v-if="price && price.waitingprice && price.waitingprice.remark"
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="info">
                {{ helpIcon }}
              </v-icon>
            </template>
            <span>{{ price.waitingprice.remark }}</span>
          </v-tooltip>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
          class="px-2"
          align-self="center"
          style="text-align:right"
        >
          <span>
            {{
              price && price.waitingprice && price.waitingprice.price
                ? price.waitingprice.price
                : 0 | formatDouble
            }}
            {{
              price && price.waitingprice && price.waitingprice.currency
                ? price.waitingprice.currency
                : price.currency
            }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1 px-3 mb-3 white rounded">
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 6 : 2"
          class="px-2"
          align-self="center"
        >
          <span>Tillæg </span>
          <v-tooltip
            bottom
            slot="append-outer"
            color="info"
            v-if="
              price && price.chargedetails && price.chargedetails.length > 0
            "
            min-width="260px"
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="info">
                {{ helpIcon }}
              </v-icon>
            </template>
            <v-flex v-for="item in price.chargedetails" :key="item.description">
              <v-row no-gutters>
                <v-col cols="8">
                  <span>
                    {{ item.description }}
                    {{ item.remark ? "(" + item.remark + ")" : "" }}
                  </span>
                </v-col>
                <v-col cols="4" style="text-align:right">
                  <span>
                    {{ item.price | formatDouble }} {{ item.currency }}
                  </span>
                </v-col>
              </v-row>
            </v-flex>
          </v-tooltip>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 2 : 8"
          class="px-2"
          align-self="center"
          style="text-align:left"
        >
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
          class="px-2"
          align-self="center"
          style="text-align:right"
        >
          <span>
            {{ price.totalchargeprice | formatDouble }}
            {{ price.currency }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1 px-3 mb-3 white rounded">
        <v-col
          :cols="this.$vuetify.breakpoint.smAndDown ? 6 : 2"
          align-self="center"
          class="px-2"
        >
          <b>Samlet estimat</b>
        </v-col>
        <v-col
          :cols="this.$vuetify.breakpoint.smAndDown ? 2 : 8"
          align-self="center"
          style="text-align:center"
          class="px-2"
        >
        </v-col>
        <v-col
          :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2"
          class="px-2"
          align-self="center"
          style="text-align:right"
        >
          <b v-if="price">
            {{
              (priceInclVat ? price.totalprice * 1.25 : price.totalprice)
                | formatDouble
            }}
            {{ price.currency }}
          </b>
        </v-col>
        <!-- vat info -->
        <v-col
          v-if="priceInclVat"
          :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 10"
          align-self="center"
          class="px-2"
        >
          <span>moms</span>
        </v-col>
        <v-col
          v-if="priceInclVat"
          :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2"
          class="px-2"
          align-self="center"
          style="text-align:right"
        >
          <span v-if="price && priceInclVat">
            {{ (price.totalprice * 1.25 - price.totalprice) | formatDouble }}
            {{ price.currency }}
          </span>
        </v-col>
        <!-- disclaimer -->
        <v-col cols="12" align-self="center" class="pt-2 px-2">
          <i>
            Husk at prisen er indikativ og kan defor ændre sig ved endt kørsel
          </i>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { dictionary } from "../helpers";
import { tools } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  components: {
    CardHeader
  },
  created() {
    const bookingType = this.$store.getters["user/bookingType"];
    const hidePrice = this.$store.getters["user/hidePrice"];
    this.priceVisible =
      !hidePrice &&
      bookingType !== dictionary.constants.booking_types.distribution;

    this.priceInclVat = this.$store.getters["user/priceInclVat"];
  },
  data: () => ({
    priceVisible: true,
    dicsountIcon: dictionary.mdi.discount,
    priceInclVat: false,
    helpIcon: dictionary.mdi.help
  }),
  filters: {
    formatDouble: function(val) {
      return tools.parseDoubleToString(parseFloat(val));
    }
  },
  computed: {
    visible: {
      get() {
        return (
          this.priceVisible &&
          this.$store.state.booking.data.account &&
          this.$store.state.booking.data.pickup.address.address &&
          this.$store.state.booking.data.pickup.address.name &&
          this.$store.state.booking.data.delivery.address.address &&
          this.$store.state.booking.data.delivery.address.name &&
          this.$store.state.booking.data.delivery.route.distance_meters > 0 &&
          this.$store.state.booking.data.pickup.timewindow.from.date != "" &&
          this.$store.state.booking.data.pickup.timewindow.from.time != "" &&
          this.$store.state.booking.data.pickup.timewindow.to.date != "" &&
          this.$store.state.booking.data.pickup.timewindow.to.time != "" &&
          this.$store.state.booking.data.vehicle_type.external_key != "" &&
          this.goodsValid()
        );
      }
    },
    price: {
      get() {
        return this.$store.state.booking.data.price;
      }
    }
  },
  methods: {
    goodsValid() {
      return (
        this.$store.state.booking.data.goods &&
        this.$store.state.booking.data.goods[0] &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].cll) > 0 &&
        this.$store.state.booking.data.goods[0].description.length > 0 &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].weight) > 0
      );
    }
  }
};
</script>
